import { GRID_GAP, MIN_TOTAL_PADDED } from '../Service/gridConfig';

const DOT_SIZE = 20;
const DOT_SM_SIZE = 20;
const DOT_RADIUS = 10;
const TRACK_HEIGHT = 20;
  const TIME_FONT      = 14;
  const TIME_LINE_H    = 20;
  const TIME_FONT_FS   = 14;
const TIME_LINE_H_FS = 20;
  const STATUS_FONT        = 14;
  const STATUS_FONT_FS     = 16;
  const STATUS_LINE_H      = 18;
  const STATUS_LINE_H_FS   = 20;
  const STATUS_PAD         = '6px 12px';
  const STATUS_PAD_FS      = '9px 16px';
  const STATUS_MIN_W       = 110;
  const STATUS_MIN_W_FS    = 124;

export const SOLID = {
  inProgress:   '#2b19ca',
  critical:     '#d32f2f',
  revalidation: '#f57c00',
  approved:     '#2e7d32',
  fail:         '#ffd000',
  notStarted:   '#333536',
  none:         '#90a4ae',
  cancelled:     '#d32f2f',
};

export const COLORS = {
  none:  SOLID.none,
  doing: SOLID.inProgress,
  done:  SOLID.approved,
  warn:  SOLID.revalidation,
  fail:  SOLID.critical,
  cancelled: SOLID.cancelled,
  revalEmissao: SOLID.fail,
};

export function getStatusCfg(tag) {
  switch (tag) {
    case 'Aprovada':
      return {
        variant: 'outline',
        bd:    SOLID.approved,
        bg:    '#EAF7EA',
        color: SOLID.approved,
        radius: 8,
      };

    case 'Em andamento':
      return {
        variant: 'outline',
        bd:    SOLID.inProgress,
        bg:    '#E8F0FE',
        color: SOLID.inProgress,
        radius: 8,
      };

    case 'Em revalidação':
      return {
        variant: 'outline',
        bd:    SOLID.revalidation,
        bg:    '#FFF3E0',
        color: SOLID.revalidation,
        radius: 8,
      };

    case 'Cancelado':
      return {
        variant: 'outline',
        bd:    SOLID.cancelled,
        bg:    '#FFEBEE',
        color: SOLID.cancelled,
        radius: 8,
      };

    case 'Não iniciada':
      return {
        variant: 'outline',
        bd:    SOLID.notStarted,
        bg:    '#F1F5F9',
        color: SOLID.notStarted,
        radius: 8,
      };

    default:
      return {
        variant: 'outline',
        bd:    SOLID.none,
        bg:    '#F1F5F9',
        color: '#37474f',
        radius: 8,
      };
  }
}

export function getRowTone(statusTag = '') {
  const norm = (statusTag || '').toLowerCase();

  if (
    norm.includes('revalidação') ||
    norm.includes('em andamento')
  ) {
    return {
      bg:     '#FFF9E6',
      border: '#F5E8B8',
      stripe: '#F4C96B',
    };
  }

  if (norm.includes('cancelado')) {
    return {
      bg:     '#F7F9FB',
      border: '#E6EBF2',
      stripe: '#E57373',
    };
  }

  if (norm.includes('não iniciada')) {
    return {
      bg:     '#F7F9FB',
      border: '#E6EBF2',
      stripe: '#CBD5E1',
    };
  }

  if (norm.includes('validado') || norm.includes('conclu')) {
    return {
      bg:     '#EAF7EA',
      border: '#CDE8CD',
      stripe: '#6FC36E',
    };
  }

  return {
    bg:     '#F8FAFD',
    border: '#E6EBF2',
    stripe: '#B0BEC5',
  };
}

export const styles = {
  rowCard: (tone, expanded) => ({
    border: `1px solid ${expanded ? '#e0e0e0' : tone.border}`,
    background: expanded ? '#ffffff' : tone.bg,
    borderRadius: 8,
    marginBottom: 5,
    overflow: 'hidden',
    cursor: 'pointer',
    transition: 'background .2s ease,border-color .2s ease, box-shadow .2s ease',
    boxShadow: expanded ? '0 2px 8px rgba(0,0,0,.05)' : 'none',
    position: 'relative',
    boxSizing: 'border-box',
    padding: '6px 0',
    minWidth: MIN_TOTAL_PADDED,
    width: `max(100%, ${MIN_TOTAL_PADDED}px)`,
  }),

  leftStripe: (tone) => ({
    content: '""',
    position: 'absolute',
    left: 0, top: 0, bottom: 0,
    width: 4,
    background: tone.stripe,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
  }),

  headerGrid: {
    display: 'grid',
    columnGap: GRID_GAP,
    alignItems: 'stretch',
    boxSizing: 'border-box',
    padding: '6px 0',
    minWidth: MIN_TOTAL_PADDED,
    width: `max(100%, ${MIN_TOTAL_PADDED}px)`,
  },

  cell: (align) => ({
    position: 'relative',
    boxSizing: 'border-box',
    padding: '0 6px',
    textAlign: align === 'right' ? 'right' : 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: align === 'right' ? 'flex-end' : 'center',

    fontSize: 14,
    lineHeight: '18px',
    fontWeight: 600,
    color: '#263238',

    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),

  stageCell: { flexDirection: 'column' },

  stageHoverArea: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },

  trackDotRow: () => ({
    height: TRACK_HEIGHT,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),

  dot: (c) => ({
    width: DOT_SIZE,
    height: DOT_SIZE,
    borderRadius: DOT_RADIUS,
    background: c,
    display: 'inline-block',
  }),

  dotSm: (c) => ({
    width: DOT_SM_SIZE,
    height: DOT_SM_SIZE,
    borderRadius: DOT_RADIUS,
    background: c,
    display: 'inline-block',
    marginRight: 6,
    position: 'relative',
    top: -1,
  }),

  tinyClock: () => ({
    width: 18,
    height: 18,
    display: 'inline-block',
  }),

  timeWrap: () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
  }),

  time: (c = SOLID.approved, fs = false) => ({
    fontSize: fs ? TIME_FONT_FS : TIME_FONT,
    lineHeight: fs ? `${TIME_LINE_H_FS}px` : `${TIME_LINE_H}px`,
    fontWeight: 700,
    color: c,
  }),

  fsCellBump: { fontSize: 13, lineHeight: '16px' },

  motoristaCpf: (fs = false) => ({
    fontSize: fs ? 14 : 12,
    color: '#607d8b',
    fontWeight: 600,
    whiteSpace: 'nowrap',
  }),
  implementoLine: (fs = false) => ({
    fontSize: fs ? 12 : 11,
    lineHeight: fs ? '18px' : '16px',
    whiteSpace: 'nowrap',
  }),

  statusPill: (bg, color = '#fff', radius = 12, fs = false) => ({
    display: 'inline-block',
    fontSize: fs ? STATUS_FONT_FS : STATUS_FONT,
    lineHeight: fs ? `${STATUS_LINE_H_FS}px` : `${STATUS_LINE_H}px`,
    fontWeight: 700,
    padding: fs ? STATUS_PAD_FS : STATUS_PAD,
    borderRadius: radius,
    background: bg,
    color,
    minWidth: fs ? STATUS_MIN_W_FS : STATUS_MIN_W,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  }),

  statusPillOutline: (
    { bd = SOLID.inProgress, bg = '#E8F0FE', color = SOLID.inProgress, radius = 8 } = {},
    fs = false
  ) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    fontSize: fs ? STATUS_FONT_FS : STATUS_FONT,
    lineHeight: fs ? `${STATUS_LINE_H_FS}px` : `${STATUS_LINE_H}px`,
    fontWeight: 700,
    padding: fs ? STATUS_PAD_FS : STATUS_PAD,
    borderRadius: radius,
    background: bg,
    color,
    border: `1px solid ${bd}`,
    minWidth: fs ? STATUS_MIN_W_FS : STATUS_MIN_W,
    whiteSpace: 'nowrap',
    textAlign: 'center',
    margin: fs ? '0 6px' : '0 4px',
  }),

  detailsWrap: { background: '#fafbfc' },
  details: { padding: 16, fontSize: 12, lineHeight: '16px', color: '#263238', position: 'relative' },
  vDivider: { position: 'absolute', left: '50%', top: 8, bottom: 8, width: 1, background: '#e3e9f3', transform: 'translateX(-0.5px)', pointerEvents: 'none' },
  colLeft:  { paddingRight: 16 },
  colRight: { paddingLeft: 16 },
  sectionHeader: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' },
  sectionTitle: { fontSize: 15, fontWeight: 600, color: '#37474f' },
  sectionPill: { display: 'inline-block', padding: '2px 8px', borderRadius: 10, background: '#eef3fa', color: '#3b5b8a', fontSize: 13, fontWeight: 600 },
  listRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 },
  listLabel: { color: '#607d8b', fontWeight: 500, fontSize: 12, display: 'flex', alignItems: 'center', gap: 6 },
  listValue: { color: '#263238', fontWeight: 600, fontSize: 12, textAlign: 'right', textTransform: 'uppercase', },
  voltaPill: (bg = '#e8f5e9', color = SOLID.approved) => ({ marginLeft: 8, padding: '2px 6px', fontSize: 11, fontWeight: 700, borderRadius: 8, background: bg, color, whiteSpace: 'nowrap' }),
  statusChipDetail: (bg) => ({ fontSize: 12, padding: '2px 8px', borderRadius: 12, background: bg, color: '#fff' }),
  clientWrap: { whiteSpace: 'normal', wordBreak: 'break-word', overflow: 'visible', textOverflow: 'unset', lineHeight: '14px', textAlign: 'center' },
  costCenterWrap: { whiteSpace: 'normal', wordBreak: 'break-word', overflow: 'visible', textOverflow: 'unset', lineHeight: '14px', textAlign: 'center' },
  vehicleWrap: { whiteSpace: 'normal', wordBreak: 'break-word', overflow: 'visible', textOverflow: 'unset', lineHeight: '14px', textAlign: 'center' },
  filialWrap: { whiteSpace: 'normal', wordBreak: 'break-word', overflow: 'visible', textOverflow: 'unset', lineHeight: '14px', textAlign: 'center' },
  cellDivider: { boxShadow: 'inset 1px 0 0 #e3e9f3' },
};

export default styles;
